import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import biIcon from './assets/biIcon.svg';
import integrationManager from './assets/integrationManager.svg';
import projectManager from './assets/projectManager.svg';
import emailIcon from './assets/emailIcon.svg';
import automationIcon from './assets/automationIcon.svg';
import { IState } from '../../config/rootReducer';
import AppCard from './components/AppCard';
import { PRODUCT_URLS } from './action/HomeAccessActions';

const HomeBodyStyle = makeStyles({
  bodySettings: {
    maxHeight: 'calc(100vh - 150px)',
    overflowY: 'auto',
    padding: '30px 40px',
  },
  bodyPadding: {
    padding: '30px 40px',
  },
  fullDimensions: {
    width: '100%',
    height: '100%',
  },
  banner: {
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '41px',
    color: '#42AFE4',
    marginLeft: 41,
  },
  bannerHeight: {
    height: 80,
    width: '100%',
    background: '#FFFFFF',
    border: '1px solid #F4F4F4',
    boxSizing: 'border-box',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
  },
  numberOfProducts: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '18px',
  },
  separationBody: {
    marginTop: 20,
    marginBottom: 20,
  },
});

/**
 * Componente que corresponde al cuerpo del dashboard donde se encuentran los
 * productos de Wholemeaning a los cuales el usuario tiene acceso.
 * @returns
 */
const HomeBody = () => {
  const access = useSelector((state: IState) => state.home.access);
  const classes = HomeBodyStyle();
  const { t } = useTranslation('common');

  const numberOfAccesses = Object.values(access).filter((value: boolean) => value).length;

  const names = {
    dashboard: t('names.dashboard'),
    project_manager: t('names.project_manager'),
    integration_manager: t('names.integration_manager'),
    bi: t('names.bi'),
    integration_dashboard: t('names.integration_dashboard'),
  };

  const banner = t('banner');

  const descriptions = {
    dashboard: t('descriptions.dashboard'),
    project_manager: t('descriptions.project_manager'),
    integration_manager: t('descriptions.integration_manager'),
    bi: t('descriptions.bi'),
    integration_dashboard: t('descriptions.integration_dashboard'),
  };

  const numberOfProducts = t('products', { number: numberOfAccesses });

  const icons = {
    dashboard: emailIcon,
    bi: biIcon,
    project_manager: projectManager,
    integration_manager: integrationManager,
    integration_dashboard: automationIcon,
  };

  return (
    <Grid container={true} className={classes.bodySettings}>
      <Grid item={true} className={classes.bannerHeight}>
        <Typography className={classes.banner}>{banner}</Typography>
      </Grid>
      <Grid item={true} className={classes.separationBody}>
        <Typography className={classes.numberOfProducts}>{numberOfProducts}</Typography>
      </Grid>
      <Grid item={true} className={classes.fullDimensions} container={true} justify="space-between">
        {Object.keys(access).map(productName => {
          return access[productName] ? (
            <>
              <AppCard
                image={icons[productName]}
                name={names[productName]}
                tooltip={descriptions[productName]}
                link={PRODUCT_URLS[productName]}
              />
            </>
          ) : (
            <></>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default HomeBody;
